var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "word-cloud-character-wrapper" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(_setup.FontSelector, {
          staticClass: "col-12",
          attrs: { disabled: _setup.disabled },
          on: { input: _setup.onFontSelected },
          model: {
            value: _setup.model.font,
            callback: function ($$v) {
              _vm.$set(_setup.model, "font", $$v)
            },
            expression: "model.font",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 d-flex align-items-center" },
          [
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: {
                type: "decimal",
                step: ".01",
                placeholder: "0.00",
                min: 0,
                label: "Min size(pts)",
                disabled: _setup.disabled,
              },
              on: {
                input: function ($event) {
                  return _setup.updateFontSize(
                    "minFontSize",
                    _setup.model.minFontSize
                  )
                },
              },
              model: {
                value: _setup.model.minFontSize,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "minFontSize", $$v)
                },
                expression: "model.minFontSize",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "mx-2" }, [_vm._v(" to ")]),
            _vm._v(" "),
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: {
                type: "decimal",
                step: ".01",
                min: 0,
                placeholder: "0.00",
                label: "Max size(pts)",
                disabled: _setup.disabled,
              },
              on: {
                input: function ($event) {
                  return _setup.updateFontSize(
                    "maxFontSize",
                    _setup.model.maxFontSize
                  )
                },
              },
              model: {
                value: _setup.model.maxFontSize,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "maxFontSize", $$v)
                },
                expression: "model.maxFontSize",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: {
                type: "number",
                min: 0,
                placeholder: "0.00",
                label: "Max Words",
                disabled: _setup.disabled,
              },
              on: {
                input: function ($event) {
                  return _setup.updateWordCloudConfig({
                    maxWords: _setup.model.maxWords,
                  })
                },
              },
              model: {
                value: _setup.model.maxWords,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "maxWords", $$v)
                },
                expression: "model.maxWords",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }